import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

/**
 * Single choice option list rendered as pills. Selection is mandatory:
 * clicking the selected pill again keeps it selected.
 */
@Component({
  selector: 'app-gray-pill-select-input',
  templateUrl: './gray-pill-select-input.component.html',
  styleUrl: './gray-pill-select-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: GrayPillSelectInputComponent
    },
  ]
})
export class GrayPillSelectInputComponent implements ControlValueAccessor {
  @Input() items: any[] = [];
  @Input() bindLabel?: string;
  @Input() bindValue?: string;
  @Input() hasError = false;
  @Input() customClass = '';
  @Input() disabled = false;
  @Output() changed = new EventEmitter();

  value: any = null;
  touched = false;

  onChange = (value: any) => {
  };

  onTouched = () => {
  };

  itemLabel(item: any) {
    return this.bindLabel ? item[this.bindLabel] : item;
  }

  itemValue(item: any) {
    return this.bindValue ? item[this.bindValue] : item;
  }

  isSelected(item: any) {
    return this.itemValue(item) === this.value;
  }

  selectItem(item: any) {
    if (this.disabled) {
      return;
    }

    this.markAsTouched();
    this.value = this.itemValue(item);
    this.changed.emit(this.value);
    this.onChange(this.value);
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
